import React, { useEffect, useState } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import { useParams, useNavigate } from "react-router-dom";
import { BiRupee } from "react-icons/bi";
import "./ViewPage.css";
import axios from "axios";

const ViewSalaryAided = () => {
   const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const { salary_id } = useParams();
  const navigate = useNavigate();

  const [staff, setStaff] = useState(null);

  useEffect(() => {
      axios.post(`${API_BASE_URL}salary_aided_detail.php`,{salary_id:salary_id})
        .then((response) => {
          if (response.data.head.code === 200 ) {
            setStaff(response.data.body);
            // setFilteredOrders(response.data.body);
            // console.log(response.data.body[0]);
  
          } else {
            console.error("Error Fetching Data:", response.data.head.msg);
            setStaff([]);
            // setFilteredOrders([]);
          }
        })
        .catch((error) => {
          console.error("API Error:", error);
          setStaff([]);
          // setFilteredOrders([]);
        }).finally(() => {
          // setLoading(false); // Set loading to false after API call
        });
    }, []);

  // useEffect(() => {
  //   // TODO: replace with real API fetch by id
  //   const fetchedData = {
  //     id: id || 1,
  //     name: "Maha",
  //     basic: 25000,
  //     sp: 2000,
  //     wa: 1500,
  //     da: 5000,
  //     hra: 3200,
  //     ma: 300,
  //     tpf: 1000,
  //     tpfd: 500,
  //     cpsr: 800,
  //     cpsa1: 600,
  //     gis: 110,
  //     nhis: 300,
  //     faCoop: 200,
  //     ptItSr: 150,
  //   };

  //   setStaff(fetchedData);
  // }, [id]);

  // const calculateSalary = (item) => {
  //   const gross =
  //     (item.basic || 0) +
  //     (item.sp || 0) +
  //     (item.wa || 0) +
  //     (item.da || 0) +
  //     (item.hra || 0) +
  //     (item.ma || 0);

  //   const deduction =
  //     (item.tpf || 0) +
  //     (item.tpfd || 0) +
  //     (item.cpsr || 0) +
  //     (item.cpsa1 || 0) +
  //     (item.gis || 0) +
  //     (item.nhis || 0) +
  //     (item.faCoop || 0) +
  //     (item.ptItSr || 0);

  //   const netSalary = gross - deduction;

  //   return { gross, deduction, netSalary };
  // };

  if (!staff) {
    return (
      <Container fluid className="outer-container my-4">
        <h2 className="text-center mb-3">View Aided Staff Salary</h2>
        <Row>
          <Col>
            <div className="not-found-box">Loading...</div>
          </Col>
        </Row>
      </Container>
    );
  }

  // const calc = calculateSalary(staff);

  const fields = [
    { label: "Staff Name", value: staff.name },
     { label: "Designation", value: staff.desig_name },
    { label: "Department", value: staff.depart_name },
    { label: "Date of Joining", value: staff.date_of_join },
    { label: "Basic Salary", value: (<><BiRupee /> {staff.basic}</>) },
    { label: "Total Days", value: staff.total_days },
    { label: "LoP", value: staff.lop },
    { label: "Working Days", value: staff.working_days },
    { label: "SP", value: (<><BiRupee /> {staff.sp}</>) },
    { label: "WA", value: (<><BiRupee /> {staff.wa}</>) },
    { label: "DA %", value: (<> {staff.da_per} %</>) },
    { label: "DA", value: (<><BiRupee /> {staff.da_amt}</>) },
    { label: "HRA", value: (<><BiRupee /> {staff.hra}</>) },
    { label: "MA", value: (<><BiRupee /> {staff.ma}</>) },
    { label: "TPF", value: (<><BiRupee /> {staff.tpf}</>) },
    { label: "TPFD", value: (<><BiRupee /> {staff.tpfd}</>) },
    { label: "CPS(R)", value: (<><BiRupee /> {staff.cps_r}</>) },
    { label: "CPS(A1)", value: (<><BiRupee /> {staff.cps_a1}</>) },
    { label: "GIS", value: (<><BiRupee /> {staff.gis}</>) },
    { label: "NHIS", value: (<><BiRupee /> {staff.nhis}</>) },
    { label: "FA/Coop", value: (<><BiRupee /> {staff.fa_coop}</>) },
    { label: "PT", value: (<><BiRupee /> {staff.pt}</>) },
    { label: "IT/SR", value: (<><BiRupee /> {staff.it_sr}</>) },
    { label: "Gross", value: (<><BiRupee /> {staff.gross}</>) },
    { label: "Deduction", value: (<><BiRupee /> {staff.deduction}</>) },
    { label: "Net Salary", value: (<><BiRupee /> {staff.net_salary}</>) },
  ];

  return (
    <Container fluid className="outer-container my-4">
      <h2 className="text-center mb-3">View Aided Staff Salary</h2>

      <div className="customer-header d-flex justify-content-end align-items-center mb-3">
        <Button className="btn-top" onClick={() => navigate(-1)}>
          Back
        </Button>
      </div>

      <div className="customer-view-wrapper">
        <div className="customer-view-card">
          <div className="customer-photo-wrap" aria-hidden />
          <div className="customer-details-table-wrapper">
            <table
              className="customer-view-table"
              role="table"
              aria-label={`Aided salary details for ${staff.name}`}
            >
              {/* <thead>
                <tr>
                  <th style={{ width: "36%" }}>Field</th>
                  <th style={{ width: "64%" }}>Value</th>
                </tr>
              </thead> */}
              <tbody>
                {fields.map((f, i) => (
                  <tr key={i}>
                    <td className="field-cell">{f.label}</td>
                    <td className="value-cell">{f.value}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default ViewSalaryAided;
